import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FeatureGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): any {
    const featureKey = String(route.data?.['featureKey'] || '').trim();
    if (!featureKey) {
      return true;
    }

    return this.authService.user$.pipe(
      take(1),
      map((user) => {
        const enabled = !!user?.features?.[featureKey];
        if (enabled) {
          return true;
        }

        this.router.navigate(['/admin/history']);
        return false;
      })
    );
  }
}
